import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IReportQueryOptions, IReportTabsResponse } from '../types';
import { REPORT_TABS_API_URL, REPORT_TABS_QUERY } from '../constants';

export default function useReportTabsQuery(
  options: Ref<IReportQueryOptions>,
): IContextQueryResult<IReportTabsResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [REPORT_TABS_QUERY, options],
    queryFn: ({ signal }) => fetchGet<IReportTabsResponse>(REPORT_TABS_API_URL, {
      signal,
      urlParams: {
        reportType: options.value.reportType,
        widgetType: options.value.widgetType,
      },
      permission: options.value.permission,
    }),
  });
}
